<template>
  <div class="m-error-page">
    <div
      class="error-page-main"
      :class="errorInfo.errorClass"
    >
      <p>{{ errorInfo.errorTxt }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: null
  },
  computed: {
    errorInfo () {
      let temp = {
        errorClass: '',
        errorTxt: ''
      }
      if (this.status === '403') {
        temp.errorClass = 'error-403'
        temp.errorTxt = this.$t('components.error.error_403')
      } else if (this.status === '404') {
        temp.errorClass = 'error-403'
        temp.errorTxt = this.$t('components.error.error_404')
      } else if (this.status === '500') {
        temp.errorClass = 'error-500'
        temp.errorTxt = this.$t('components.error.error_500')
      } else if (this.status === 'no-auth') {
        temp.errorClass = 'error-no-auth'
        temp.errorTxt = this.$t('components.error.error_no_auth')
      }
      return temp
    }
  }
}
</script>

<style lang="less" scoped>
.m-error-page {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  overflow: hidden;
  .error-page-main {
    position: absolute;
    top: 50%;
    width: 100%;
    height: 460px;
    margin-top: -250px;
    p {
      position: absolute;
      top: 420px;
      left: 0;
      right: 0;
      width: 100%;
      padding: 0 32px;
      box-sizing: border-box;
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .error-page-main:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    width: 480px;
    height: 400px;
    margin: auto;
    background-repeat: no-repeat;
    background-position: center;
  }
  .error-403:before {
    background-image: url("../../assets/images/error403.png");
  }
  .error-404:before {
    background-image: url("../../assets/images/error404.png");
  }
  .error-500:before {
    background-image: url("../../assets/images/error500.png");
  }
  .error-no-auth:before {
    background-image: url("../../assets/images/no-auth.png");
  }
}
</style>
